const config = {
  routes: {
    label: 'New FAQs',
    prefix: '/new_programme_faqs',
  },
}

export default config
